// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".explorer-statistics[data-v-1f8c71d4]{display:flex;flex-direction:column;gap:20px}.explorer-charts[data-v-1f8c71d4]{display:flex;gap:10px;flex-wrap:wrap;overflow-x:hidden;overflow-y:scroll;height:620px;padding-right:20px}.explorer-chart[data-v-1f8c71d4]{position:relative;width:calc(50% - 10px);height:180px}", ""]);
// Exports
module.exports = exports;
